


import React, { useEffect, useMemo, useState, useRef } from "react";
import {
  Box,
  Typography,
  IconButton,
  MenuItem,
  Menu,
  useMediaQuery,
  ClickAwayListener,
  CircularProgress
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import search from "../../assets/Dashboard/search.svg";
import notification from "../../assets/Dashboard/notification.svg";
import person from "../../assets/Dashboard/person.svg";
import CustomText, { textStyles } from "../CustomText";
import more from "../../assets/Dashboard/more.svg";
import activenotification from "../../assets/activenotification.svg";
import notification1 from "../../assets/notification1.svg";
import notification3 from "../../assets/notification3.svg";
import activemore from "../../assets/activemore.svg";
import profileicon from "../../assets/profileicon.svg";
import changepassword from "../../assets/changepassword.svg";
import logouticon from "../../assets/logouticon.svg";
import mark from "../../assets/mark.svg";
import arrowdown from "../../assets/arrowdown.svg";
import ProfileDrawer from "../../pages/AdminPages/Dashboard/ProfileDrawer";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../Redux/Slices/AuthSlice";
import ChangePassword from "../../pages/AdminPages/Dashboard/ChangePassword";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import Japan from "../../assets/Japan.svg";
import spanish from "../../assets/spanish.svg";
import dollarsign from "../../assets/Dashboard/dollarsign.svg";
import LogoutModal from "../LogoutModel";
import { BASE_URL } from "../../components/BaseUrl";
import { decryptToken } from "../../Utlis/Encryption";
import MarkEmailReadOutlinedIcon from "@mui/icons-material/MarkEmailReadOutlined";

const DashboardHeader = ({  isMobile, toggleSidebar, toggleHeaderMenu, showHeaderMenu }) => {
  const [showNotifications, setShowNotifications] = useState(false);
  const [showMoreOptions, setShowMoreOptions] = useState(false);
  const [showProfileDrawer, setShowProfileDrawer] = useState(false);
  const [showGlobalSearch, setShowGlobalSearch] = useState(false);
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [logoutModalOpen, setLogoutModalOpen] = useState(false);
    // const [profile, setProfile] = useState(null);
const { profile } = useSelector((state) => state.profile);
const [unreadCount, setUnreadCount] = useState(0);

  const { user } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const { t, i18n } = useTranslation();
  useEffect(() => {
    console.log("Updated Profile in Header:", profile);
  }, [profile]);
  const language = i18n.language === "es" ? "Español" : "English";
  const currentFlag = language === "English" ? Japan : spanish;
  const handleSelect = (lang) => {
    i18n.changeLanguage(lang === "English" ? "en" : "es");
    setAnchorEl(null);
  };

  // const [profile, setProfile] = useState(null);
  const rawEncryptedToken = localStorage.getItem("token");
  const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null;

  

  const getProfileImageSrc = (raw) => {
    if (!raw) return person;
    if (raw.startsWith("data:")) return raw;
    if (/^https?:\/\//i.test(raw)) return raw;
    const prefix = raw.startsWith("/") ? "" : "/";
    return `${BASE_URL}${prefix}${raw}`;
  };

  // ---------- GLOBAL SEARCH (STATIC HEADINGS; NO NAV) ----------
  const [searchTerm, setSearchTerm] = useState("");

  // Use translations so it matches UI text in current language
  const headings = useMemo(
    () => [
      t("previous_7_days") || "Previous 7 Days",
      t("registered_companies") || "Registered Companies",
      t("inactive_accounts") || "All inactive accounts",
      t("previous_30_days") || "Previous 30 Days",
      t("all_account_executives") || "All account executives",
      t("most_paid_subscriptions") || "Most paid subscriptions",
      t("payouts") || "Payouts",
    ],
    // recompute when language changes
    [i18n.language, t]
  );

  const filteredItems = useMemo(() => {
    const q = searchTerm.trim().toLowerCase();
    if (!q) return headings;
    return headings.filter((h) => h.toLowerCase().includes(q));
  }, [searchTerm, headings]);

  // Close on ESC key for good UX
  const onSearchKeyDown = (e) => {
    if (e.key === "Escape") setShowGlobalSearch(false);
  };
const fetchUnreadCount = async () => {
  try {
    const response = await fetch(
      `${BASE_URL}/notifications/account-executive/unread-count`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const data = await response.json();
    if (!data.error) {
      setUnreadCount(data.data.unread_count || 0);
    }
  } catch (error) {
    console.error("❌ Failed to fetch unread count", error);
  }
};

useEffect(() => {
  fetchUnreadCount();
}, []);
  const LanguageSelector = (
    <>
      <Box
        onClick={(e) => setAnchorEl(e.currentTarget)}
        display="flex"
        alignItems="center"
        gap={0.4}
        sx={{
          backgroundColor: "#091E420F",
          height: "40px",
          borderRadius: "4.34px",
          padding: "0px 18px",
          fontSize: "1rem",
          cursor: "pointer",
        }}
      >
        {/* <Box component="img" src={currentFlag} alt="Language Flag" sx={{ width: 22, height: 22, objectFit: "contain", mr: 1 }} /> */}
        <Typography variant="body2" sx={{ fontSize: 14, color: "#172B4D", fontWeight: 400, fontFamily: "Poppins, sans-serif" }}>
          {language}
        </Typography>
        <ExpandMoreIcon fontSize="small" sx={{ ml: 0.5 }} />
      </Box>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{
          sx: {
            mt: 1,
            borderRadius: "8px",
            px: 0,
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
            border: "1px solid #ccc",
            width: isMobile ? "50%" : isTablet ? "20%" : "8%",
          },
        }}
      >
        <MenuItem onClick={() => handleSelect("Spanish")} sx={{ gap: 1 }}>
          {/* <Box component="img" src={spanish} alt="Spanish" sx={{ width: 20, height: 20 }} /> */}
          <Typography variant="body2" sx={{ fontSize: 14, color: "#172B4D", fontWeight: 400, fontFamily: "Poppins, sans-serif" }}>
             {t("spanish")}
          </Typography>
        </MenuItem>
        <MenuItem onClick={() => handleSelect("English")} sx={{ gap: 1 }}>
          {/* <Box component="img" src={Japan} alt="English" sx={{ width: 20, height: 20 }} /> */}
          <Typography variant="body2" sx={{ fontSize: 14, color: "#172B4D", fontWeight: 400, fontFamily: "Poppins, sans-serif" }}>
             {t("english")}
          </Typography>
        </MenuItem>
      </Menu>
    </>
  );

  const handleLogoutConfirm = () => {
    dispatch(logout());
    setShowMoreOptions(false);
    navigate("/");
    setLogoutModalOpen(false);
  };



  const [notifications, setNotifications] = useState([]);
const [loading, setLoading] = useState(true);
const [marking, setMarking] = useState(false);

const fetchNotifications = async () => {
  setLoading(true);
  try {
    const response = await fetch(`${BASE_URL}/notifications/account-executive??limit=5&offset=0`, {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await response.json();
    if (data.success) setNotifications(data.data.notifications);
  } catch (error) {
    console.error("Error fetching notifications:", error);
  } finally {
    setLoading(false);
  }
};

const markAllAsRead = async () => {
  setMarking(true);
  try {
    const response = await fetch(`${BASE_URL}/notifications/account-executive/mark-all-read`, {
      method: "PUT",
      headers: { Authorization: `Bearer ${token}` },
    });
    if (response.ok) fetchNotifications();
  } catch (error) {
    console.error("Error marking all as read:", error);
  } finally {
    setMarking(false);
  }
};

useEffect(() => {
  if (showNotifications) fetchNotifications();
}, [showNotifications]);

  return (
    <>
      {/* ClickAway to close NOTIFICATIONS only */}
      <ClickAwayListener onClickAway={() => setShowNotifications(false)}>
        <Box
          sx={{
            height: 70,
            px: 2,
            display: "flex",
            py: isMobile ? 3 : 2,
            alignItems: "center",
            justifyContent: "space-between",
            borderBottom: "1px solid #E0E0E0",
            backgroundColor: "#FFFFFF",
          }}
        >
          {isMobile ? (
            <>
              <IconButton onClick={toggleSidebar}>
                <MenuIcon />
              </IconButton>
              <CustomText sx={{ ...textStyles.h1, fontSize: 18, fontWeight: 700, color: "#172B4D" }}>
                {t("account_executive")}
              </CustomText>
              <IconButton onClick={toggleHeaderMenu}>
                <MoreVertIcon />
              </IconButton>
            </>
          ) : (
            <>
              <CustomText sx={{ ...textStyles.h1, fontSize: 20, fontWeight: 700, color: "#172B4D" }}>
                {t("account_executive")}
              </CustomText>

              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                {LanguageSelector}

                {/* 🔍 Search trigger (no ClickAway here) */}
                {/* <Box
                  component="img"
                  src={search}
                  alt="search"
                  sx={{ width: 20, height: 20, cursor: "pointer" }}
                  onClick={() => setShowGlobalSearch((p) => !p)}
                /> */}

                {/* 🔔 Notifications */}
           <Box sx={{ position: "relative", cursor: "pointer" }} onClick={() => navigate("/notifications")}>
  <Box
    component="img"
    src={showNotifications ? activenotification : notification}
    alt="notification"
    sx={{ width: 24, height: 24 }}
  />

  {unreadCount > 0 && (
    <Box
      sx={{
        position: "absolute",
        top: -6,
        right: -6,
        minWidth: 18,
        height: 18,
        backgroundColor: "#E53935",
        color: "#fff",
        borderRadius: "50%",
        fontSize: 11,
        fontWeight: 600,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: unreadCount > 9 ? 0.8 : 0,
      }}
    >
      {unreadCount > 99 ? "99+" : unreadCount}
    </Box>
  )}
</Box>


                {/* Profile + more */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}
                 onClick={() => setShowMoreOptions((prev) => !prev)}>
                  <Box
                    component="img"
                    crossOrigin="anonymous"
                    src={getProfileImageSrc(profile?.profile_picture)}
                    alt="user"
                    sx={{ width: 32, height: 32, borderRadius: "50%" }}
                     onError={(e) => {
e.currentTarget.onerror = null; // prevent infinite loop
e.currentTarget.src = person;
}}
                  />
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <CustomText sx={{ ...textStyles.body5, color: "#363333", fontSize: "15px", fontWeight: 500, pt: 1.2, textAlign: "left", letterSpacing: "0px !important" }}>
                      {/* {profile?.full_name || `${profile?.first_name || ""} ${profile?.last_name || ""}` || "John Doe"} */}
                   
           {profile?.first_name} {profile?.middle_name}  {profile?.last_name}
                    </CustomText>
                    <CustomText sx={{ ...textStyles.body5, color: "#939393", fontSize: "13px", fontWeight: 400, pt: 0, textAlign: "left", letterSpacing: "0px !important" }}>
{profile?.email}                    </CustomText>
                  </Box>

                  <ClickAwayListener onClickAway={() => setShowMoreOptions(false)}>
                    <Box
                      component="img"
                      src={showMoreOptions ? activemore : more}
                      alt="more"
                     
                      sx={{ width: 18, height: 18, ml: 0, cursor: "pointer" }}
                    />
                  </ClickAwayListener>
                </Box>
              </Box>
            </>
          )}

          {/* More options dropdown */}
          {showMoreOptions && (
            <Box
              sx={{
                position: "absolute",
                top: isMobile ? 170 : 70,
                right: 25,
                width: 190,
                backgroundColor: "#fff",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                borderRadius: "6px",
                overflow: "hidden",
                zIndex: 2000,
              }}
            >
              {[
                {
                  label: t("profile"),
                  icon: profileicon,
                  action: () => {
                    setShowMoreOptions(false);
                    setShowProfileDrawer(true);
                    if (isMobile) toggleHeaderMenu();
                  },
                },
               {
  label: t("tabs.profileUpdate"),
  icon: profileicon,
  action: () => {
    setShowMoreOptions(false);

    navigate("/settings/account", {
      state: { fromProfile: true },
    });

    if (isMobile) toggleHeaderMenu();
  },
},
                {
                  label: t("change_password"),
                  icon: changepassword,
                  action: () => {
                    setShowMoreOptions(false);
                    if (isMobile) toggleHeaderMenu();
                    setOpen(true);
                  },
                },
                { label: t("logout"), icon: logouticon, action: () => setLogoutModalOpen(true) },
              ].map((item, i) => (
                <Box
                  key={i}
                  onClick={item.action}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    px: 2,
                    py: 1.2,
                    borderBottom: i < 2 ? "1px solid #eee" : "none",
                    cursor: "pointer",
                    "&:hover": { backgroundColor: "#F5F5F5" },
                  }}
                >
                  <Box component="img" src={item.icon} alt={item.label} sx={{ width: 18, height: 18 }} />
                  <Typography sx={{ fontSize: "13px", fontWeight: 500, color: "#222529", fontFamily: "Poppins, sans-serif" }}>
                    {item.label}
                  </Typography>
                </Box>
              ))}
            </Box>
          )}

          <ChangePassword open={open} onClose={() => setOpen(false)} />
          <ProfileDrawer open={showProfileDrawer} onClose={() => setShowProfileDrawer(false)} />

          {/* Notifications panel */}
        {showNotifications && (
  <Box
    sx={{
      position: "absolute",
      top: isMobile ? 170 : 70,
      right: isMobile ? 0 : 200,
      width: isMobile ? 320 : 420,
      backgroundColor: "#fff",
      boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
      borderRadius: "0px",
      overflow: "hidden",
      zIndex: 2000,
      display: "flex",
      flexDirection: "column",
      maxHeight: 400,
    }}
  >
    {/* Header */}
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        px: 2,
        py: 1.5,
        borderBottom: "1px solid #eee",
      }}
    >
      <Typography sx={{ fontSize: 16, fontWeight: 600, color: "#222529", fontFamily: "Poppins, sans-serif" }}>
        {t("notifications")}
      </Typography>
      <IconButton
        onClick={markAllAsRead}
        disabled={marking}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          backgroundColor: "#006EC2",
          color: "white",
          px: 1.5,
          py: 0.5,
          borderRadius: "6px",
          "&:hover": { backgroundColor: "#005bb5" },
        }}
      >
        {marking ? (
          <CircularProgress size={16} sx={{ color: "white" }} />
        ) : (
          <>
            <MarkEmailReadOutlinedIcon sx={{ fontSize: 16 }} />
            <Typography sx={{ fontSize: 13, fontFamily: "Poppins, sans-serif" }}>
              {t("markAsRead")}
            </Typography>
          </>
        )}
      </IconButton>
    </Box>

    {/* Notifications List */}
    <Box
      sx={{
        overflowY: "auto",
        maxHeight: 300,
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": { display: "none" },
      }}
    >
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 250 }}>
          <CircularProgress size={32} />
        </Box>
      ) : notifications.length === 0 ? (
        <Box sx={{ textAlign: "center", py: 3 }}>
          <Typography sx={{ fontSize: 14, color: "#777" }}> {t("empty.no_user")}</Typography>
        </Box>
      ) : (
        notifications.map((n, i) => (
          <Box
            key={i}
            sx={{
              px: 2,
              py: 1.2,
              borderBottom: "1px solid #eee",
              backgroundColor: !n.is_read ? "#EAF4FF" : "white",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box>
              <Typography sx={{ fontSize: 14, fontWeight: 600, color: "#222", fontFamily: "Poppins, sans-serif" }}>
                {n.title}
              </Typography>
              <Typography sx={{ fontSize: 13, color: "#555", fontFamily: "Poppins, sans-serif" }}>
                {n.message}
              </Typography>
             
            </Box>
          </Box>
        ))
      )}
    </Box>

  
  </Box>
)}

          {/* ======= GLOBAL SEARCH DROPDOWN ======= */}
          {showGlobalSearch && (
            <ClickAwayListener onClickAway={() => setShowGlobalSearch(false)}>
              <Box
                className="global-search-box"
                sx={{
                  position: "absolute",
                  top: 70,
                  right: 80,
                  width: 400,
                  backgroundColor: "#fff",
                  borderRadius: 2,
                  boxShadow: "0px 6px 24px rgba(0, 0, 0, 0.12)",
                  px: 2,
                  py: 1.5,
                  zIndex: 3000,
                }}
                onClick={(e) => e.stopPropagation()} // prevent bubbling to any parent handlers
              >
                {/* Search input */}
                <Box sx={{ position: "relative", mb: 2, borderBottom: "1px solid rgba(170, 162, 162, 0.42)" }}>
                  <input
                    type="text"
                    placeholder={t("search_placeholder") || "Search globally..."}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onKeyDown={onSearchKeyDown}
                    style={{
                      width: "100%",
                      padding: "10px 36px 10px 12px",
                      fontSize: "14px",
                      border: "none",
                      outline: "none",
                      borderRadius: "8px",
                      fontFamily: "Poppins, sans-serif",
                    }}
                  />
                  <Box
                    sx={{
                      position: "absolute",
                      right: 10,
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      fontSize: 18,
                      color: "#6B7280",
                      fontWeight: 500,
                    }}
                    onClick={() => setShowGlobalSearch(false)}
                  >
                    ×
                  </Box>
                </Box>

                {/* Results (filter from headings only) */}
                {filteredItems.length > 0 ? (
                  filteredItems.map((text, i) => (
                    <CustomText
                      key={`${text}-${i}`}
                      sx={{
                        ...textStyles.body5,
                        pb: 0.8,
                        color: "#181818",
                        fontSize: "14px",
                        fontWeight: 400,
                        textAlign: "left",
                        cursor: "pointer",
                      }}
                      onClick={(e) => {
                        e.stopPropagation(); // keep dropdown open
                        setSearchTerm(text); // fill input (dummy action for now)
                      }}
                    >
                      {text}
                    </CustomText>
                  ))
                ) : (
                  <CustomText
                    sx={{
                      ...textStyles.body5,
                      pb: 0.8,
                      color: "#999",
                      fontSize: "13px",
                      fontWeight: 400,
                      textAlign: "left",
                    }}
                  >
                    {t("no_results") || "No results found"}
                  </CustomText>
                )}
              </Box>
            </ClickAwayListener>
          )}

          {/* Mobile menu */}
          {isMobile && showHeaderMenu && (
            <Box
              sx={{
                position: "absolute",
                top: "70px",
                right: 0,
                width: "100%",
                backgroundColor: "#FFFFFF",
                boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                zIndex: 1300,
                px: 2,
                py: 1.3,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}>
                {LanguageSelector}
                {/* <Box component="img" src={search} alt="search" sx={{ width: 20, height: 20, cursor: "pointer" }} onClick={() => setShowGlobalSearch((p) => !p)} /> */}
             <Box sx={{ position: "relative", cursor: "pointer" }} onClick={() => navigate("/notifications")}>
  <Box
    component="img"
    src={showNotifications ? activenotification : notification}
    alt="notification"
    sx={{ width: 24, height: 24 }}
  />

  {unreadCount > 0 && (
    <Box
      sx={{
        position: "absolute",
        top: -6,
        right: -6,
        minWidth: 18,
        height: 18,
        backgroundColor: "#E53935",
        color: "#fff",
        borderRadius: "50%",
        fontSize: 11,
        fontWeight: 600,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: unreadCount > 9 ? 0.8 : 0,
      }}
    >
      {unreadCount > 99 ? "99+" : unreadCount}
    </Box>
  )}
</Box>

              </Box>

              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}
               onClick={() => setShowMoreOptions((prev) => !prev)}>
                <Box component="img" 
                   crossOrigin="anonymous" 
                                   src={getProfileImageSrc(profile?.profile_picture)}
 alt="user" sx={{ width: 32, height: 32, borderRadius: "50%" }} 
 onError={(e) => {
e.currentTarget.onerror = null; // prevent infinite loop
e.currentTarget.src = person;
}}/>
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <CustomText sx={{ ...textStyles.body5, color: "#363333", fontSize: "15px", fontWeight: 500, pt: 1.2, textAlign: "left", letterSpacing: "0px !important" }}>
              {profile?.profile?.first_name
                  ? `${profile?.profile?.first_name}  ${profile?.profile?.middle_name} ${profile?.profile?.last_name}`
                  : "John Doe"}
                  </CustomText>
                  <CustomText sx={{ ...textStyles.body5, color: "#939393", fontSize: "13px", fontWeight: 400, pt: 0, textAlign: "left", letterSpacing: "0px !important" }}>
                                             {profile?.profile?.email || "john.doe@gmail.com"}

                  </CustomText>
                </Box>

                <Box
                  component="img"
                  src={showMoreOptions ? activemore : more}
                  alt="more"
                  onClick={() => setShowMoreOptions((prev) => !prev)}
                  sx={{ width: 16, height: 16, ml: 1, cursor: "pointer" }}
                />
              </Box>
            </Box>
          )}
        </Box>
      </ClickAwayListener>

      <LogoutModal open={logoutModalOpen} onClose={() => setLogoutModalOpen(false)} onConfirm={handleLogoutConfirm} t={t} />
    </>
  );
};

export default DashboardHeader;


